// ============================================
// EDIT/CREATE ENVIRONMENT DIALOG CONTROLLER (Version Constraints)
// - Templates filtered by descending version rule
// - Only populate dropdown after envType is selected
// Location: profile/tabs/environments/environment-dialog-controller.js
// ============================================

angular.module('bizmetryApp').controller('EnvironmentDialogController',
    function ($scope, $mdDialog, $timeout, ProfileService, environment, availableTemplates, envTypes, currentEnvs, isNew, profileId) {

        $scope.isNew = isNew;
        // Pre-check del orquestador sobre el template elegido: { checking, allowed, reason }
        $scope.assignmentCheck = null;
        var assignmentCheckSeq = 0;
        $scope.availableTemplates = availableTemplates || [];
        $scope.envTypes = envTypes || [];
        $scope.currentEnvs = currentEnvs || [];
        $scope.validationMessage = '';
        $scope.filteredEnvTypes = [];

        console.log('EnvironmentDialogController init. isNew=', isNew);
        console.log('RECIBI currentEnvs=', $scope.currentEnvs);

        // ── CSS DIAGNOSTICO — remover después de confirmar fix ──
        $timeout(function () {
            // 1. Badge: clase y color computado
            var badge = document.querySelector('.env-tvb, .template-version-badge');
            if (badge) {
                console.log('[CSS-DIAG] Badge clase:', badge.className);
                console.log('[CSS-DIAG] Badge background computado:', window.getComputedStyle(badge).backgroundColor);
            } else {
                console.warn('[CSS-DIAG] Badge NO encontrado en DOM');
            }

            // 2. Toolbar: justify-content computado
            var toolbar = document.querySelector('.edit-env-dialog .md-toolbar-tools');
            if (toolbar) {
                console.log('[CSS-DIAG] Toolbar justify-content:', window.getComputedStyle(toolbar).justifyContent);
            } else {
                console.warn('[CSS-DIAG] Toolbar NO encontrado');
            }

            // 3. Stylesheets cargados en orden — buscar cuál tiene template-version-badge
            var sheets = Array.from(document.styleSheets);
            console.log('[CSS-DIAG] Total stylesheets:', sheets.length);
            sheets.forEach(function (ss, i) {
                try {
                    var rules = Array.from(ss.cssRules || []);
                    rules.forEach(function (rule) {
                        if (rule.selectorText && (
                            rule.selectorText.includes('template-version-badge') ||
                            rule.selectorText.includes('env-tvb')
                        )) {
                            console.log('[CSS-DIAG] Sheet', i, ss.href ? ss.href.split('/').pop() : 'inline',
                                '| selector:', rule.selectorText,
                                '| bg:', rule.style.background || rule.style.backgroundColor || '(none)');
                        }
                    });
                } catch (e) { /* cross-origin */ }
            });

            // 4. Verificar si env-tvb existe en algún stylesheet
            var envTvbFound = false;
            sheets.forEach(function (ss) {
                try {
                    Array.from(ss.cssRules || []).forEach(function (rule) {
                        if (rule.selectorText && rule.selectorText.includes('env-tvb')) {
                            envTvbFound = true;
                        }
                    });
                } catch (e) {}
            });
            console.log('[CSS-DIAG] .env-tvb encontrado en algún stylesheet:', envTvbFound);

        }, 800);
        // ── FIN DIAGNOSTICO ──

        // ============================================
        // VERSION COMPARISON UTILITIES
        // ============================================

        function compareVersions(v1, v2) {
            if (!v1 || !v2) return 0;

            var p1 = v1.toString().split('.');
            var p2 = v2.toString().split('.');

            var M1 = parseInt(p1[0], 10) || 0;
            var N1 = parseInt(p1[1], 10) || 0;

            var M2 = parseInt(p2[0], 10) || 0;
            var N2 = parseInt(p2[1], 10) || 0;

            if (M1 !== M2) return M1 - M2;
            return N1 - N2;
        }

        function getEnvTypeIdSafe(env) {
            if (!env) return null;
            if (env.envTypeId != null) return parseInt(env.envTypeId, 10);
            if (env.environmentTypeId != null) return parseInt(env.environmentTypeId, 10);
            if (env.environmentType_id != null) return parseInt(env.environmentType_id, 10);
            return null;
        }

        // ============================================
        // POSITION & VERSION CONSTRAINTS
        // ============================================

        function getInsertPosition() {
            if (!$scope.env.envTypeId) return null;

            var envTypeId = getEnvTypeIdSafe($scope.env);

            // En modo EDIT, retornar la posición actual
            if (!isNew && environment) {
                var currentIndex = $scope.currentEnvs.findIndex(function (e) {
                    return e.id === environment.id;
                });
                return currentIndex !== -1 ? currentIndex : null;
            }

            // En modo CREATE, encontrar dónde se insertaría basado en envTypeId
            for (var i = 0; i < $scope.currentEnvs.length; i++) {
                var existingEnvTypeId = getEnvTypeIdSafe($scope.currentEnvs[i]);
                if (existingEnvTypeId > envTypeId) {
                    return i; // Insertar antes de este
                }
            }

            return $scope.currentEnvs.length; // Al final
        }

        function getVersionConstraints() {
            var position = getInsertPosition();

            if (position === null) {
                return { prevVersion: null, nextVersion: null };
            }

            var prevVersion = null;
            var nextVersion = null;

            // Obtener versión del environment ANTERIOR (si existe)
            if (position > 0) {
                var prevEnv = $scope.currentEnvs[position - 1];
                prevVersion = prevEnv.templateInstanceVersion || null;
            }

            // Obtener versión del environment SIGUIENTE (si existe)
            if (position < $scope.currentEnvs.length) {
                var nextEnv = $scope.currentEnvs[position];

                // En modo EDIT, skip el current environment
                if (!isNew && nextEnv.id === environment.id) {
                    if (position + 1 < $scope.currentEnvs.length) {
                        nextEnv = $scope.currentEnvs[position + 1];
                        nextVersion = nextEnv.templateInstanceVersion || null;
                    }
                } else {
                    nextVersion = nextEnv.templateInstanceVersion || null;
                }
            }

            console.log('📐 Version constraints for position', position, ':', {
                prevVersion: prevVersion,
                nextVersion: nextVersion
            });

            return { prevVersion: prevVersion, nextVersion: nextVersion };
        }

        // ============================================
        // Snapshot & change detection
        // ============================================

        $scope.originalEnv = null;

        function normalizeEnv(e) {
            if (!e) return null;
            return {
                name: (e.name || '').trim(),
                description: (e.description || '').trim(),
                envType: e.envType || null,
                envTypeId: e.envTypeId || null,
                selectedTemplateId: e.selectedTemplateId || null,
                isEnabled: !!e.isEnabled
            };
        }

        $scope.hasChanges = function () {
            if ($scope.isNew) return true;
            if (!$scope.originalEnv) return false;

            return !angular.equals(
                normalizeEnv($scope.env),
                normalizeEnv($scope.originalEnv)
            );
        };

        // ============================================
        // EnvTypes filtering
        // ============================================

        // ============================================
        // EnvTypes filtering (con orden ascendente)
        // ============================================

        $scope.filterEnvTypes = function () {
            console.log('🔍 Filtering envTypes');

            if (!$scope.envTypes || !$scope.currentEnvs) {
                $scope.filteredEnvTypes = $scope.envTypes || [];
                return;
            }

            var usedEnvTypes = $scope.currentEnvs
                .map(function (env) { return env.envType; });

            // En EDIT mode, no excluir el envType actual
            if (!$scope.isNew && $scope.env && $scope.env.envType) {
                usedEnvTypes = usedEnvTypes.filter(function (t) {
                    return t !== $scope.env.envType;
                });
            }

            // Filtrar tipos no usados
            $scope.filteredEnvTypes = $scope.envTypes.filter(function (type) {
                return usedEnvTypes.indexOf(type.refObjectLabel) === -1;
            });

            // ✅ ORDENAR por refObjectId ascendente (Development < Staging < Production)
            $scope.filteredEnvTypes.sort(function (a, b) {
                var idA = parseInt(a.refObjectId, 10) || 0;
                var idB = parseInt(b.refObjectId, 10) || 0;
                return idA - idB;
            });

            console.log('✅ Filtered envTypes (ordered):', $scope.filteredEnvTypes);
        };

        // ============================================
        // Init env model
        // ============================================

        if (isNew) {
            $scope.env = {
                name: '',
                description: '',
                envType: null,
                envTypeId: null,
                templateInstanceId: null,
                templateInstanceStatus: null,
                templateInstanceVersion: null,
                selectedTemplateId: null,
                isEnabled: false
            };

            $timeout(function () {                            // ← diferir un tick
                $scope.filterEnvTypes();
                $scope.originalEnv = angular.copy($scope.env);
            });

        } else {
            $scope.env = angular.copy(environment || {});

            if ($scope.env.envType && typeof $scope.env.envType === 'object') {
                $scope.env.envType = $scope.env.envType.refObjectLabel || $scope.env.envType;
            }

            $scope.env.selectedTemplateId = $scope.env.templateInstanceId || null;

            // ✅ Cachear el nombre del template para el label (fallback si el md-select no resuelve el match)
            if ($scope.env.templateInstanceId) {
                var initTemplate = $scope.availableTemplates.find(function (t) {
                    return t.id === $scope.env.templateInstanceId;
                });
                if (initTemplate) {
                    $scope.env.templateInstanceName = initTemplate.templateName;
                    $scope.env.templateInstanceStatus = $scope.env.templateInstanceStatus || initTemplate.templateStatus;
                    $scope.env.templateInstanceVersion = $scope.env.templateInstanceVersion || initTemplate.templateVersion;
                }
            }

            $scope.filterEnvTypes();

            $timeout(function () {
                if ($scope.env.envType) {
                    var matchingType = $scope.envTypes.find(function (t) {
                        return t.refObjectLabel === $scope.env.envType;
                    });
                    if (matchingType) {
                        $scope.env.envTypeId = matchingType.refObjectId.toString();
                    }
                }

                $scope.originalEnv = angular.copy($scope.env);
                console.log('📝 Edit dialog initialized:', $scope.env);
            });
        }

        // ============================================
        // Event Handlers
        // ============================================

        $scope.onEnvTypeChanged = function () {
            console.log('🔄 Environment type changed to:', $scope.env.envType);

            var matchingType = $scope.envTypes.find(function (t) {
                return t.refObjectLabel === $scope.env.envType;
            });

            $scope.env.envTypeId = matchingType ? matchingType.refObjectId.toString() : null;

            // ✅ Diferir el re-filtrado para que el md-select termine de cerrar primero
            $timeout(function () {
                $scope.filterEnvTypes();

                $scope.env.selectedTemplateId = null;
                $scope.env.templateInstanceId = null;
                $scope.env.templateInstanceStatus = null;
                $scope.env.templateInstanceVersion = null;
                $scope.env.templateInstanceName = null; // ✅ limpiar cache de nombre

                $scope.updateValidationMessage();
            });
        };

        // Con el agente fuera de línea, el orquestador no deja asignar un template que cambia la
        // estructura de resource types con resources ya importados en este environment (la
        // conciliación tendría que releerlos del datasource). Sólo aplica a environments guardados.
        function checkTemplateAssignment() {
            var seq = ++assignmentCheckSeq;
            var templateId = $scope.env.selectedTemplateId;

            if (isNew || !$scope.env.id || !profileId || !templateId) {
                $scope.assignmentCheck = null;
                return;
            }

            $scope.assignmentCheck = { checking: true, allowed: false, reason: 'Checking whether this template can be applied...' };

            ProfileService.checkTemplateAssignment(profileId, $scope.env.id, templateId)
                .then(function (response) {
                    if (seq !== assignmentCheckSeq) return; // llegó la respuesta de una selección anterior
                    var result = response.data || {};
                    $scope.assignmentCheck = {
                        checking: false,
                        allowed: result.allowed === true,
                        reason: result.allowed === true ? '' : (result.reason || 'This template cannot be applied right now.')
                    };
                })
                .catch(function (error) {
                    if (seq !== assignmentCheckSeq) return;
                    var reason = error && error.data && error.data.reason;
                    $scope.assignmentCheck = {
                        checking: false,
                        allowed: false,
                        reason: reason || 'Could not verify whether this template can be applied. Select it again to retry.'
                    };
                });
        }

        $scope.isAssignmentBlocked = function () {
            return !!($scope.assignmentCheck && !$scope.assignmentCheck.allowed);
        };

        $scope.onTemplateSelected = function () {
            console.log('📄 Template selected:', $scope.env.selectedTemplateId);

            checkTemplateAssignment();

            if (!$scope.env.selectedTemplateId) {
                $scope.env.templateInstanceId = null;
                $scope.env.templateInstanceStatus = null;
                $scope.env.templateInstanceVersion = null;
                $scope.validationMessage = '';
                return;
            }

            var template = $scope.availableTemplates.find(function (t) {
                return t.id === $scope.env.selectedTemplateId;
            });

            if (template) {
                $scope.env.templateInstanceId = template.id;
                $scope.env.templateInstanceStatus = template.templateStatus;
                $scope.env.templateInstanceVersion = template.templateVersion;
                $scope.env.templateInstanceName = template.templateName; // ✅ cache para el label

                console.log('  → Template details:', {
                    status: template.templateStatus,
                    version: template.templateVersion,
                    name: template.templateName
                });

                if (!isNew && template.templateStatus !== 'PUBLISHED' && $scope.env.isEnabled) {
                    console.log('  → Auto-disabling environment (non-PUBLISHED template)');
                    $scope.env.isEnabled = false;
                }
            }

            $scope.updateValidationMessage();
        };

        // ============================================
        // ✅ TEMPLATE FILTERING WITH VERSION CONSTRAINTS
        // ============================================

        $scope.getAvailableTemplates = function () {
            // ✅ No mostrar templates si no hay envType seleccionado
            if (!$scope.env.envType) {
                console.log('⚠️ No envType selected, returning empty template list');
                return [];
            }

            var isDevelopment = $scope.env.envType === 'Development';

            // Primer filtro: por status y envType
            var filtered = $scope.availableTemplates.filter(function (template) {
                if (template.templateStatus === 'PUBLISHED') return true;
                if (isDevelopment) return true;
                return false;
            });

            // ✅ Segundo filtro: por constraints de versión descendente
            var constraints = getVersionConstraints();

            if (constraints.prevVersion || constraints.nextVersion) {
                console.log('🔒 Applying version constraints:', constraints);

                filtered = filtered.filter(function (template) {
                    var version = template.templateVersion;

                    // Debe cumplir: prevVersion >= version >= nextVersion

                    // Si hay prev, version debe ser <= prev
                    if (constraints.prevVersion) {
                        if (compareVersions(version, constraints.prevVersion) > 0) {
                            console.log('  ❌ Rejected', version, '(greater than prev', constraints.prevVersion + ')');
                            return false;
                        }
                    }

                    // Si hay next, version debe ser >= next
                    if (constraints.nextVersion) {
                        if (compareVersions(version, constraints.nextVersion) < 0) {
                            console.log('  ❌ Rejected', version, '(less than next', constraints.nextVersion + ')');
                            return false;
                        }
                    }

                    console.log('  ✅ Accepted', version);
                    return true;
                });
            }

            // Ordenar por versión descendente (mayor primero)
            filtered.sort(function (a, b) {
                var partsA = (a.templateVersion || '0.0').split('.').map(Number);
                var partsB = (b.templateVersion || '0.0').split('.').map(Number);
                if (partsB[0] !== partsA[0]) return partsB[0] - partsA[0];
                return partsB[1] - partsA[1];
            });

            console.log('✅ Available templates after filtering:', filtered.length);

            return filtered;
        };

        // ============================================
        // Validation
        // ============================================

        $scope.isTemplateValidForEnv = function () {
            if (!$scope.env.selectedTemplateId) return true;

            var template = $scope.availableTemplates.find(function (t) {
                return t.id === $scope.env.selectedTemplateId;
            });

            if (!template) return false;
            if (template.templateStatus === 'PUBLISHED') return true;
            if ($scope.env.envType === 'Development') return true;

            return false;
        };

        $scope.canEnableEnvironment = function () {
            if (isNew) return false;

            if (!$scope.env.selectedTemplateId) return true;

            var template = $scope.availableTemplates.find(function (t) {
                return t.id === $scope.env.selectedTemplateId;
            });

            if (!template) return false;

            return template.templateStatus === 'PUBLISHED';
        };

        $scope.updateValidationMessage = function () {
            if (!$scope.env.selectedTemplateId) {
                $scope.validationMessage = '';
                return;
            }

            var template = $scope.availableTemplates.find(function (t) {
                return t.id === $scope.env.selectedTemplateId;
            });

            if (!template) {
                $scope.validationMessage = 'Template not found';
                return;
            }

            if (template.templateStatus !== 'PUBLISHED' && $scope.env.envType !== 'Development') {
                $scope.validationMessage = 'Only PUBLISHED templates can be used in non-DEVELOPMENT environments';
            } else {
                $scope.validationMessage = '';
            }
        };

        $scope.isValid = function () {
            return $scope.env.name &&
                $scope.env.name.trim().length > 0 &&
                $scope.env.envType &&
                $scope.isTemplateValidForEnv() &&
                $scope.env.description &&
                $scope.env.description.trim().length > 0;
        };

        $scope.getSelectedTemplateName = function () {
            // Buscar por selectedTemplateId primero, luego por templateInstanceId como fallback
            var id = $scope.env.selectedTemplateId || $scope.env.templateInstanceId;
            if (!id) return '';

            var template = $scope.availableTemplates.find(function (t) {
                return t.id === id;
            });

            // Si encontramos el template en la lista, usar su nombre
            if (template) return template.templateName;

            // Fallback: usar el nombre cacheado en el env (seteado al inicializar)
            return $scope.env.templateInstanceName || '';
        };

        // ============================================
        // Actions
        // ============================================

        $scope.save = function () {
            if (!$scope.isValid() || (!$scope.isNew && !$scope.hasChanges())) {
                console.warn('❌ Cannot save: Form invalid or no changes');
                return;
            }

            if ($scope.isAssignmentBlocked()) {
                console.warn('❌ Cannot save: template assignment blocked —', $scope.assignmentCheck.reason);
                return;
            }

            if (isNew) $scope.env.isEnabled = false;

            console.log((isNew ? '➕' : '💾') + ' Saving environment:', $scope.env);
            $mdDialog.hide($scope.env);
        };

        $scope.cancel = function () {
            console.log('❌ Dialog cancelled');
            $mdDialog.cancel();
        };

        // Initial validation state
        $scope.updateValidationMessage();

    });